/*
  Options payantes Visée (2e face gravée, 2e photo…)
  -------------------------------------------------
  Une option = un produit Shopify non répertorié (ex. « Option gravure 2e face », 5 €),
  ajouté au panier À CÔTÉ du bijou. Pas de variante en plus sur le bijou : son stock
  reste unique.

  Côté fiche produit, un customizer (gravure, photo) déclare une option active avec :
    <input type="hidden" form="<id du formulaire produit>" data-vb-addon="<id de variante>">
  (sans attribut name, donc jamais envoyé lui-même ; `disabled` = option inactive).

  1) Ajout : juste avant que Tinker envoie le formulaire, on ajoute les options au panier,
     puis on relance l'envoi du bijou. Bijou et options partagent un jeton `_lien`
     (propriété cachée), et le bijou porte la liste de ses options dans `_options`.
  2) Synchronisation : à chaque mise à jour du panier, chaque option suit la quantité
     de son bijou. Bijou retiré -> option retirée ; option retirée seule -> remise.
  3) Prix affiché : la fiche ajoute au prix de la variante celui des options actives.
*/
(function () {
  'use strict';
  if (window.__viseeOptions) return;
  window.__viseeOptions = true;

  var SOURCE = 'visee-options';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function activeAddons(form) {
    var formId = form.getAttribute('id');
    if (!formId) return [];
    var nodes = document.querySelectorAll('[data-vb-addon][form="' + formId + '"]');
    var ids = [];
    nodes.forEach(function (n) {
      if (!n.disabled && n.dataset.vbAddon && ids.indexOf(n.dataset.vbAddon) === -1) ids.push(n.dataset.vbAddon);
    });
    return ids;
  }

  function setHidden(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('form', form.getAttribute('id'));
    input.setAttribute('data-vb-temp', '');
    form.appendChild(input);
  }

  function clearTemp(form) {
    form.querySelectorAll('[data-vb-temp]').forEach(function (n) { n.remove(); });
  }

  function showError() {
    window.alert("Votre option n'a pas pu être ajoutée au panier. Merci de réessayer.");
  }

  // Capture sur window : passe AVANT le gestionnaire de Tinker (capture sur document)
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.dataset.vbAddonsReady === '1') {
      // 2e passage : les options sont au panier, on laisse Tinker envoyer le bijou
      delete form.dataset.vbAddonsReady;
      setTimeout(function () { clearTemp(form); }, 0);
      return;
    }

    var addons = activeAddons(form);
    if (!addons.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.vbAddonsBusy === '1') return;
    form.dataset.vbAddonsBusy = '1';

    var qtyInput = form.querySelector('[name="quantity"]') || document.querySelector('[name="quantity"][form="' + form.getAttribute('id') + '"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var token = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: addons.map(function (id) {
          return { id: Number(id), quantity: qty, properties: { _lien: token } };
        }),
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        clearTemp(form);
        setHidden(form, 'properties[_lien]', token);
        setHidden(form, 'properties[_options]', addons.join(','));
        form.dataset.vbAddonsReady = '1';
        form.requestSubmit();
      })
      .catch(function (e) {
        console.error(e);
        showError();
      })
      .finally(function () {
        delete form.dataset.vbAddonsBusy;
      });
  }, true);

  // ===== Synchronisation panier =====
  var syncing = false;

  function sync() {
    if (syncing) return;
    syncing = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var wanted = {}; // "<lien>|<variante>" -> quantité attendue
        cart.items.forEach(function (item) {
          var p = item.properties || {};
          if (!p._lien || !p._options) return;
          String(p._options).split(',').forEach(function (vid) {
            var k = p._lien + '|' + vid;
            wanted[k] = (wanted[k] || 0) + item.quantity;
          });
        });

        var updates = {};
        var adds = [];
        var seen = {};
        cart.items.forEach(function (item) {
          var p = item.properties || {};
          if (!p._lien || p._options) return; // pas une option
          var k = p._lien + '|' + item.variant_id;
          // Une seule ligne par option et par bijou, à la quantité du bijou (0 = retirée)
          var keep = seen[k] ? 0 : (wanted[k] || 0);
          seen[k] = true;
          if (keep !== item.quantity) updates[item.key] = keep;
        });
        Object.keys(wanted).forEach(function (k) {
          if (!seen[k]) {
            var parts = k.split('|');
            adds.push({ id: Number(parts[1]), quantity: wanted[k], properties: { _lien: parts[0] } });
          }
        });

        var jobs = [];
        if (Object.keys(updates).length) {
          jobs.push(fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates }),
          }));
        }
        if (adds.length) {
          jobs.push(fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: adds }),
          }));
        }
        if (!jobs.length) return;

        return Promise.all(jobs)
          .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (fresh) {
            var ev = new Event('cart:update', { bubbles: true });
            ev.detail = { resource: fresh, sourceId: SOURCE, data: { source: SOURCE, itemCount: fresh.item_count } };
            document.dispatchEvent(ev);
          });
      })
      .catch(function (e) { console.error(e); })
      .finally(function () { syncing = false; });
  }

  document.addEventListener('cart:update', function (event) {
    var d = event.detail || {};
    if (d.sourceId === SOURCE) return;
    // Laisse Tinker finir sa propre mise à jour avant de relire le panier
    setTimeout(sync, 400);
  });

  // ===== Prix affiché sur la fiche =====
  // Le prix du thème ne connaît que la variante. On y ajoute les options actives
  // (data-vb-addon-price, en centimes) pour que la fiche affiche le vrai total
  // (ex. 74,90 + 2e photo 15 = 89,90). Le thème remplace le bloc prix à chaque
  // changement de variante : on repart alors de son nouveau texte.
  var priceTimer = null;

  function addonTotal(formId) {
    var total = 0;
    document.querySelectorAll('[data-vb-addon][form="' + formId + '"]').forEach(function (n) {
      if (!n.disabled) total += parseInt(n.dataset.vbAddonPrice, 10) || 0;
    });
    return total;
  }

  function withAddons(text, extra) {
    var m = text.match(/(\d[\d\s  .]*)([,.])(\d{2})(?!\d)/);
    if (!m) return null;
    var cents = parseInt(m[1].replace(/[^\d]/g, '') + m[3], 10) + extra;
    var amount = Math.floor(cents / 100) + m[2] + ('0' + (cents % 100)).slice(-2);
    return text.replace(m[0], amount);
  }

  function refreshPrices() {
    priceTimer = null;
    var formIds = [];
    document.querySelectorAll('[data-vb-addon][form]').forEach(function (n) {
      var id = n.getAttribute('form');
      if (formIds.indexOf(id) === -1) formIds.push(id);
    });
    formIds.forEach(function (formId) {
      var form = document.getElementById(formId);
      var scope = form && form.closest('.shopify-section, dialog');
      if (!scope) return;
      var extra = addonTotal(formId);
      scope.querySelectorAll('product-price .price, product-price .compare-at-price').forEach(function (span) {
        var current = span.textContent;
        // Texte écrit par nous -> on garde la base ; sinon le thème vient de le remplacer
        var base = (span.dataset.vbShown === current && span.dataset.vbBase) ? span.dataset.vbBase : current;
        var shown = extra ? withAddons(base, extra) : base;
        if (shown === null) return;
        span.dataset.vbBase = base;
        span.dataset.vbShown = shown;
        if (current !== shown) span.textContent = shown;
      });
    });
  }

  function schedulePrices() {
    if (!priceTimer) priceTimer = setTimeout(refreshPrices, 50);
  }

  function watchPrices() {
    if (!document.querySelector('[data-vb-addon]')) return;
    new MutationObserver(schedulePrices).observe(document.body, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'],
    });
    schedulePrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
    document.addEventListener('DOMContentLoaded', watchPrices);
  } else {
    sync();
    watchPrices();
  }
})();
